module.exports = __webpack_public_path__ + "static/media/Vignet NR indication-ax.68a3c8a5.svg";